import type {
	ReviewCycleDetailsLegacyResponseFrontend,
	ReviewCycleDetailsLegacyResponseJson,
} from "@performyard/service-contracts";

import request from "../base-request";

export const reviewCycleDownloadGoalDiscussionCsv = async (reviewCycleID: string) => {
	const [data] = await request<any>(`/review-cycle/${reviewCycleID}/goal-discussion-csv`);

	return data.user_permissions;
};

export const reviewCycleForms = async (reviewCycleID?: string) => {
	if (!reviewCycleID) return;

	const [data] = await request<any>(`/api/review-cycles/${reviewCycleID}/forms`);
	return data;
};

export const getReviewCycleDetailsLegacy = async (reviewCycleID: string) => {
	const [data] = await request<ReviewCycleDetailsLegacyResponseJson>(`/api/review_cycle/${reviewCycleID}/details`);

	const parsedResp: ReviewCycleDetailsLegacyResponseFrontend = {
		...data,
		start_date: new Date(data.start_date),
	};

	return parsedResp;
};

export const reviewCycleMeta = async (reviewCycleID?: string) => {
	if (!reviewCycleID) return;

	const [data] = await request<any>(`/api/review_cycle/${reviewCycleID}/progress/meta`);
	return data;
};
